import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import { localize } from 'helpers/translator'
import FullOverlay from 'views/overlay/full_overlay/FullOverlay'
import Bodymovin from 'components/bodymovin/bodymovin'
import myLibraryActions from 'redux/actions/my_library_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import styles from './flocabulary_announcement_overlay.scss'

class FlocabularyAnnouncementOverlay extends PureComponent {

	createAsset() {
		return (
			<Bodymovin
				path='/assets/media/animations/flocabulary/flocabulary.json'
				loop={true}
			>
				<div className={styles.animation}></div>
			</Bodymovin>
		)
	}

	render() {

		return (
			<FullOverlay
				headerWithBorder={true}
				assetSource={this.createAsset()}
				assetWidth='80%'
				primaryTextButton={localize('action_flocab_got_it')}
				primaryActionHandler={this.props.actions.continue}
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		continue: myLibraryActions.flocabularyAnnouncementContinue,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(FlocabularyAnnouncementOverlay)

export { FlocabularyAnnouncementOverlay }
